import { useMutation as o } from "@apollo/client";
import { deserializeResponse as a } from "../../graphql/deserialize/index.js";
import u from "../../graphql/mutation/bindFingerprint.js";
import { useCallback as c } from "react";
const I = () => {
  const [t, { loading: r }] = o(u);
  return {
    mutate: c(
      async (s) => {
        const { requestId: e, visitorId: i } = s, n = await t({
          variables: {
            fingerprintInput: {
              requestID: e,
              visitorID: i
            }
          }
        });
        return a(n);
      },
      [t]
    ),
    loading: r
  };
};
export {
  I as default
};
//# sourceMappingURL=useBindFingerprint.js.map
